import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

// export default new Router({
//   routes: [
//     // {
//     //   path: '/mbodymap',
//     //   component: Layout,
//     //   children: [
//     //     {
//     //       path: '/home',
//     //       component: () => import('@/views/homepage/mbodymap')
//     //     }
//     //   ]
//     // },
//     {
//       path: '/',
//       component: Layout,
//       redirect: '/mbodymap',
//       children: [
//         {
//           path: 'mbodymap',
//           component: () => import('@/views/homepage/mbodymap')
//         }
//       ]
//     },
//     {
//       path: '/site',
//       component: Layout,
//       children: [
//         {
//           path: '/site/bodysite/:site',
//           name: 'bodysite',
//           component: () => import('@/views/bodySitePage/bodysite')
//         },
//         {
//           path: '/site/bodysite/gut/:site',
//           name: 'gut',
//           component: () => import('@/views/bodySitePage/gut')
//         }
//       ]
//     },
//     {
//       path: '/phenotype',
//       component: Layout,
//       children: [
//         {
//           path: '/phenotype',
//           name: 'phenotype',
//           component: () => import('@/views/phenotypePage/phenotypeIndex')
//         },
//         {
//           path: '/phenotypeDetail/:mesh_id',
//           name: 'phenotypeDetail',
//           component: () => import('@/views/phenotypePage/phenotypeDetail')
//         },
//         {
//           path: '/phenotype/:site/:phenotype',
//           name: 'phenotypeInSite',
//           component: () => import('@/views/phenotypePage/phenotype')
//         }
//       ]
//     },
//     {
//       path: '/taxons',
//       component: Layout,
//       children: [
//         {
//           path: '/taxons/species',
//           name: 'species',
//           component: () => import('@/views/taxonsPage/species')
//         },
//         {
//           path: '/taxons/species/inBodySite/:ncbi_taxon_id',
//           name: 'taxonsToBodySite',
//           component: () => import('@/views/taxonsToAllSitePage/taxonsToSite')
//         },
//         {
//           path: '/taxons/species/:site/:ncbi_taxon_id',
//           name: 'taxonsToBodySiteDetail',
//           component: () => import('@/views/taxonsToOneSitePage/taxonsDetails')
//         },
//         {
//           path: '/taxons/species/:site/:phenotype/:ncbi_taxon_id',
//           name: 'taxonsSpeciesFinalPage',
//           component: () => import('@/views/taxonsFinalPage/speciesFinalPage')
//         },
//         {
//           path: '/taxons/genera',
//           name: 'genus',
//           component: () => import('@/views/taxonsPage/genus')
//         },
//         {
//           path: '/taxons/genera/inBodySite/:ncbi_taxon_id',
//           name: 'genusToBodySite',
//           component: () => import('@/views/taxonsToAllSitePage/genusToSite')
//         },
//         {
//           path: '/taxons/genera/:site/:ncbi_taxon_id',
//           name: 'genusToBodySiteDetail',
//           component: () => import('@/views/taxonsToOneSitePage/genusDetails')
//         },
//         {
//           path: '/taxons/genera/:site/:phenotype/:ncbi_taxon_id',
//           name: 'taxonsGenusFinalPage',
//           component: () => import('@/views/taxonsFinalPage/genusFinalPage')
//         }
//       ]
//     },
//     {
//       path: '/data',
//       component: Layout,
//       children: [
//         {
//           path: '/data',
//           component: () => import('@/views/data/data')
//         },
//         {
//           path: '/data/project/:projectId',
//           name: 'project',
//           component: () => import('@/views/data/project')
//         },
//         {
//           path: '/data/run/:runId',
//           name: 'run',
//           component: () => import('@/views/data/run')
//         }
//       ]
//     },
//     {
//       path: '/help',
//       component: Layout,
//       children: [
//         {
//           path: '/help',
//           name: 'help',
//           component: () => import('@/views/help/help')
//         }
//       ]
//     }
//   ]
// })c
const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: 'home',
          component: () => import('@/views/homepage/mbodymap')
        }
      ]
    },
    {
      path: '/bodysite',
      component: Layout,
      children: [
        {
          path: '/site/:site',
          name: 'bodysite',
          component: () => import('@/views/bodySitePage/bodysite')
        },
        {
          path: '/site/gut/:site',
          name: 'gut',
          component: () => import('@/views/bodySitePage/gut')
        }
      ]
    },
    {
      path: '/phenotype',
      component: Layout,
      children: [
        {
          path: '/health&diseases',
          name: 'phenotype',
          component: () => import('@/views/phenotypePage/phenotypeIndex')
        },
        {
          path: '/health&diseases/:phenotype/:mesh_id',
          name: 'phenotypeDetail',
          component: () => import('@/views/phenotypePage/phenotypeDetail')
        },
        {
          path: '/health&diseases/:site/:phenotype/:mesh_id',
          name: 'phenotypeInSite',
          component: () => import('@/views/phenotypePage/phenotype')
        },
        {
          path: '/health-diseases comparisons',
          name: 'markerPhenotype',
          component: () => import('@/views/phenotypePage/markerPhenotype')
        }
      ]
    },
    {
      path: '/umaptest',
      component: Layout,
      children: [
        {
          path: '/umaptest',
          name: 'umaptest',
          component: () => import('@/views/taxonsPage/umaptest')
        }
      ]
    },
    {
      path: '/celltype',
      component: Layout,
      children: [
        {
          path: '/celltypes',
          name: 'celltype',
          component: () => import('@/views/taxonsPage/celltype')
        },
        {
          path: '/celltypes/:species',
          name: 'celltype',
          component: () => import('@/views/taxonsPage/celltype')
        },
        {
          path: '/celltypes/cluster/:cluster',
          name: 'taxonsToCluster',
          component: () => import('@/views/taxonsToOneSitePage/clusterDetails')
        },
        {
          path: '/celltypes/pmid/:pmid',
          name: 'taxonsToPMID',
          component: () => import('@/views/taxonsToOneSitePage/paperDetails')
        },
        {
          path: '/celltypes/:site/:ncbi_taxon_id',
          name: 'taxonsToBodySiteDetail',
          component: () => import('@/views/taxonsToOneSitePage/taxonsDetails')
        },
        {
          path: '/celltypes/:site/:phenotype/:ncbi_taxon_id',
          name: 'taxonsSpeciesFinalPage',
          component: () => import('@/views/taxonsFinalPage/speciesFinalPage')
        }
      ]
    },
    {
      path: '/markers',
      component: Layout,
      children: [
        {
          path: '/markers',
          name: 'markers',
          component: () => import('@/views/phenotypePage/marker')
        },
        {
          path: '/markers/:gene',
          name: 'markersToDetails',
          component: () => import('@/views/taxonsToOneSitePage/markerDetails')
        }
        // {
        //   path: '/markers/pmid/:pmid',
        //   name: 'taxonsToPMID',
        //   component: () => import('@/views/taxonsToOneSitePage/paperDetails')
        // },
        // {
        //   path: '/markers/:site/:ncbi_taxon_id',
        //   name: 'taxonsToBodySiteDetail',
        //   component: () => import('@/views/taxonsToOneSitePage/taxonsDetails')
        // },
        // {
        //   path: '/markers/:site/:phenotype/:ncbi_taxon_id',
        //   name: 'taxonsSpeciesFinalPage',
        //   component: () => import('@/views/taxonsFinalPage/speciesFinalPage')
        // }
      ]
    },
    {
      path: '/brainregions',
      component: Layout,
      children: [
        {
          path: '/brainregions',
          name: 'brainregions',
          component: () => import('@/views/taxonsPage/ConditionBrain')
        },
        {
          path: '/brainregions',
          name: 'brainregions',
          component: () => import('@/views/taxonsPage/ConditionBrain')
        },
        {
          path: '/brainregions/regions/:region/:species',
          name: 'brainregionsregion',
          component: () => import('@/views/taxonsPage/ConditionBrain')
        }
      ]
    },
    {
      path: '/Conditions',
      component: Layout,
      children: [
        {
          path: '/Conditions/Species',
          name: 'species',
          component: () => import('@/views/taxonsPage/Conditionspecies')
        },
        {
          path: '/Conditions/Development',
          name: 'Development',
          component: () => import('@/views/taxonsPage/ConditionDevelop')
        },
        {
          path: '/Conditions/Disease',
          name: 'Development',
          component: () => import('@/views/taxonsPage/ConditionDisease')
        },
        {
          path: '/Conditions/Disease/:disease',
          name: 'DiseaseRoute',
          component: () => import('@/views/taxonsPage/ConditionDisease')
        },
        {
          path: '/taxon/species/:ncbi_taxon_id',
          name: 'taxonsToBodySite',
          component: () => import('@/views/taxonsToAllSitePage/taxonsToSite')
        },
        {
          path: '/taxon/species/:site/:ncbi_taxon_id',
          name: 'taxonsToBodySiteDetail',
          component: () => import('@/views/taxonsToOneSitePage/taxonsDetails')
        },
        {
          path: '/taxon/species/:site/:phenotype/:ncbi_taxon_id',
          name: 'taxonsSpeciesFinalPage',
          component: () => import('@/views/taxonsFinalPage/speciesFinalPage')
        },
        {
          path: '/taxon/genera',
          name: 'genus',
          component: () => import('@/views/taxonsPage/genus')
        },
        {
          path: '/taxon/genera/:ncbi_taxon_id',
          name: 'genusToBodySite',
          component: () => import('@/views/taxonsToAllSitePage/genusToSite')
        },
        {
          path: '/taxon/genera/:site/:ncbi_taxon_id',
          name: 'genusToBodySiteDetail',
          component: () => import('@/views/taxonsToOneSitePage/genusDetails')
        },
        {
          path: '/taxon/genera/:site/:phenotype/:ncbi_taxon_id',
          name: 'taxonsGenusFinalPage',
          component: () => import('@/views/taxonsFinalPage/genusFinalPage')
        },
        {
          path: '/taxon/markertaxa',
          name: 'markertaxa',
          component: () => import('@/views/taxonsPage/markerTaxa')
        }
      ]
    },
    {
      path: '/data',
      component: Layout,
      children: [
        {
          path: '/data',
          component: () => import('@/views/data/dataNew')
        },
        {
          path: '/data/project/:projectId',
          name: 'project',
          component: () => import('@/views/data/project')
        },
        {
          path: '/data/run/:runId',
          name: 'run',
          component: () => import('@/views/data/run')
        },
        {
          path: '/data/curatedprojects',
          name: 'curatedprojects',
          component: () => import('@/views/data/markerProjects')
        }
      ]
    },
    {
      path: '/help',
      component: Layout,
      children: [
        {
          path: '/help',
          name: 'help',
          component: () => import('@/views/help/help')
        }
      ]
    }
  ]
})

router.afterEach((to, from) => {
  // ...
  // console.log('new router')
  document.scrollingElement.scrollTop = 0
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js